let message = require('./message');
let merge = require('lodash.merge');

function readNameFromFilters(filters, identifier) {
    if (!filters) {
        // TODO What should happen if someone provides a bad filter?
        return null;
    }
    let requestedId = identifier || '';
    let filter = filters.find((item) => {
        return item.value === requestedId;
    });
    if (filter) {
        return filter.label;
    }
    return null;
}

function getOpeningsPageTitle(
    query,
    categoryFilters,
    locationFilters,
    options,
) {
    let linguaString;
    let settings = merge({}, options);

    let validCategoryName = readNameFromFilters(
        categoryFilters,
        query.category,
    );
    let validLocationName = readNameFromFilters(
        locationFilters,
        query.location,
    );

    const INTERN_STRING = 'Intern';
    const isInternFilterApplied =
        query.type && query.type.toLowerCase() === INTERN_STRING.toLowerCase();

    if (validCategoryName && validLocationName) {
        linguaString = 'careers.openings.type.in.title';
        settings.hash.CATEGORY = validCategoryName;
        settings.hash.LOCATION = validLocationName;
    } else if (validCategoryName) {
        linguaString = 'careers.openings.type.title';
        settings.hash.CATEGORY = validCategoryName;
    } else if (validLocationName) {
        linguaString = 'careers.openings.all.in.title';
        settings.hash.LOCATION = validLocationName;
    } else if (isInternFilterApplied) {
        linguaString = 'careers.openings.type.title';
        settings.hash.CATEGORY = INTERN_STRING;
    } else {
        linguaString = 'careers.openings.all.title';
    }

    if (isInternFilterApplied && settings.hash.CATEGORY !== INTERN_STRING) {
        settings.hash.CATEGORY += ` ${INTERN_STRING}`;
    }

    return message(linguaString, settings);
}

module.exports = getOpeningsPageTitle;
